import { BankAccount } from 'app/shared/models/bank-account.model';

/**
 * Model to manage the payment transaction's related data.
 */
export class PaymentModel {
    id: number;
    clientId: number;
    clientEntityId: number;
    clientName: string;
    clientTxnAccountNo: number;
    clientAccounts: BankAccount[];
    counterPartyEntityId: number;
    counterPartyName: string;
    counterPartyTxnAccNo: number;
    counterPartyAccounts: BankAccount[];
    amount: number;
    chargeType: string;
    communication: string;
    currency: string;
    processedToBank: boolean;
    reference: string;
    remarks: string;
    status: number;
    txnDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/payment.model.ts